"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function invalidMethod() {
    return 1;
}
exports.invalidMethod = invalidMethod;



// WEBPACK FOOTER //
// ./src/index.ts